import type { Alert, Severity } from '../api/types/hd';

const RANK: Record<Severity, number> = { critical: 0, warning: 1, info: 2 };
/** Critical first, then warning, then info; stable within a severity. */
export const sortAlerts = (alerts: readonly Alert[]) =>
  alerts.slice().sort((a, b) => RANK[a.severity] - RANK[b.severity]);
